import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
const serv_prod = {
  '321300': { APP_HOST: 'https://app.suxinwen.cn', WWW_HOST: 'https://www.suxinwen.cn', API_HOST: 'https://api.suxinwen.cn' }
}
const serv_dev = {
  '321300': { APP_HOST: 'https://app-test.suxinwen.chinacici.com', WWW_HOST: 'http://www.suxinwen.chinacici.com', API_HOST: 'http://api.suxinwen.chinacici.com' }
}
console.log(process.env.NODE_ENV)
export default new Vuex.Store({
  state: {
    serv: process.env.NODE_ENV == 'development' || process.env.NODE_ENV == 'test' ? serv_dev : serv_prod
  },
  mutations: {},
  actions: {},
  modules: {}
})
